import { render, staticRenderFns } from "./MenageVehiclesGroup.vue?vue&type=template&id=5a5bd9ab&scoped=true&"
import script from "./MenageVehiclesGroup.vue?vue&type=script&lang=js&"
export * from "./MenageVehiclesGroup.vue?vue&type=script&lang=js&"
import style0 from "./MenageVehiclesGroup.vue?vue&type=style&index=0&id=5a5bd9ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bd9ab",
  null
  
)

export default component.exports